import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "px-2 py-0 pt-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_select_filled = _resolveComponent("v-select-filled")!
  const _component_v_combobox_filled = _resolveComponent("v-combobox-filled")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_editor = _resolveComponent("editor")!
  const _component_v_btn_primary = _resolveComponent("v-btn-primary")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_AccountingConfigAPI = _resolveComponent("AccountingConfigAPI")!
  const _component_InvoiceThirdCompanyUsersDialog = _resolveComponent("InvoiceThirdCompanyUsersDialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_oss_dialog, {
      modelValue: _ctx.dialog,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.dialog) = $event)),
      title: _ctx.title,
      class: "px-2",
      minWidth: '60vw'
    }, {
      actions: _withCtx(() => [
        _createVNode(_component_v_btn_primary, {
          disabled: !_ctx.isValid,
          rounded: "",
          block: "",
          loading: _ctx.loading,
          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.sendMails())),
          "data-cy": "MailerDialogue-valid",
          size: "x-large"
        }, {
          default: _withCtx(() => _cache[16] || (_cache[16] = [
            _createTextVNode("Envoyer")
          ])),
          _: 1
        }, 8, ["disabled", "loading"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_v_form, {
          modelValue: _ctx.isValid,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.isValid) = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_select_filled, {
              modelValue: _ctx.mailAddressSender,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.mailAddressSender) = $event)),
              items: _ctx.credentialsEmailAddresses,
              "item-value": "item",
              rules: [_ctx.rules.notEmpty],
              label: "Mail qui va envoyer la facture",
              class: "px-2 mb-0 mt-1",
              "append-icon": "$add",
              "onClick:append": _cache[1] || (_cache[1] = ($event: any) => (_ctx.accountingConfigAPIDialog = true)),
              "item-title": (item) => item.email
            }, null, 8, ["modelValue", "items", "rules", "item-title"]),
            (!_ctx.sendMultipleMails)
              ? (_openBlock(), _createBlock(_component_v_combobox_filled, {
                  key: 0,
                  modelValue: _ctx.mailAddressesDestination,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.mailAddressesDestination) = $event)),
                  items: _ctx.thirdCompanyData.users,
                  rules: [_ctx.rules.onlyEmails],
                  label: "À",
                  class: "px-2 pt-2",
                  "item-key": "email",
                  multiple: "",
                  chips: "",
                  "closable-chips": "",
                  density: "compact",
                  "append-icon": "$add",
                  "onClick:append": _cache[3] || (_cache[3] = ($event: any) => (_ctx.thirdCompanyUsersDialog = true)),
                  "item-title": (item) => _ctx.displayTPCData(item)
                }, null, 8, ["modelValue", "items", "rules", "item-title"]))
              : _createCommentVNode("", true),
            (_ctx.mailTemplates?.length > 1)
              ? (_openBlock(), _createBlock(_component_v_select_filled, {
                  key: 1,
                  label: "Modèle de mail",
                  modelValue: _ctx.selectedTemplateName,
                  "onUpdate:modelValue": [
                    _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedTemplateName) = $event)),
                    _ctx.loadTemplateContent
                  ],
                  items: _ctx.mailTemplates,
                  "item-title": "title",
                  class: "px-2 pt-2",
                  "data-cy": "MailerDialog-mailTemplate"
                }, null, 8, ["modelValue", "items", "onUpdate:modelValue"]))
              : _createCommentVNode("", true),
            _createVNode(_component_v_text_field_filled, {
              modelValue: _ctx.subjectMailToSend,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.subjectMailToSend) = $event)),
              rules: [_ctx.rules.notEmpty],
              label: "Objet",
              class: "px-2 pt-2",
              "single-line": ""
            }, null, 8, ["modelValue", "rules"])
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_editor, {
            modelValue: _ctx.textMail,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.textMail) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createVNode(_component_v_snackbar, {
          modelValue: _ctx.mailSent,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.mailSent) = $event))
        }, {
          actions: _withCtx(() => [
            _createVNode(_component_v_btn, {
              color: "green",
              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.mailSent = false)),
              variant: "text"
            }, {
              default: _withCtx(() => _cache[17] || (_cache[17] = [
                _createTextVNode(" Close ")
              ])),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _cache[18] || (_cache[18] = _createTextVNode(" Mail envoyé "))
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_AccountingConfigAPI, {
      modelValue: _ctx.accountingConfigAPIDialog,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.accountingConfigAPIDialog) = $event)),
      config: _ctx.accountingConfig.config,
      profileId: _ctx.accountingConfig.profileId,
      companyId: _ctx.accountingConfig.companyId,
      mailUsage: 'sendingMail',
      onOnUpdate: _cache[13] || (_cache[13] = ($event: any) => (_ctx.refresh()))
    }, null, 8, ["modelValue", "config", "profileId", "companyId"]),
    (_ctx.thirdCompanyUsersDialog)
      ? (_openBlock(), _createBlock(_component_InvoiceThirdCompanyUsersDialog, {
          key: 0,
          modelValue: _ctx.thirdCompanyUsersDialog,
          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.thirdCompanyUsersDialog) = $event)),
          companyId: _ctx.companyId,
          thirdPartyCompanyId: _ctx.thirdPartyCompanyId,
          onlyToCreate: true,
          onValid: _cache[15] || (_cache[15] = ($event: any) => (_ctx.refresh()))
        }, null, 8, ["modelValue", "companyId", "thirdPartyCompanyId"]))
      : _createCommentVNode("", true)
  ]))
}